(function () {

    "use strict";

    function configurationService($q, $rootScope, $http, SOLPHEO) {

        var self = this;

        self.loadConfiguracion = function () {
            var defered = $q.defer();
            var promise = defered.promise;

            if ($rootScope.configApi == null) {
                $rootScope.configApi = SOLPHEO;
            }

            defered.resolve($rootScope.configApi);

            return promise;
        };

        self.getActivityIdWorkflow = function (workflowName, taskName) {
            var defered = $q.defer();
            var promise = defered.promise;
            self.loadConfiguracion().then(function (data) {
                var workflow = data.workFlows.filter(function (woorkflow) {
                    return woorkflow.activities.some(function (activity) {
                        return activity.name === taskName && woorkflow.name === workflowName;
                    });
                });

                defered.resolve((workflow != null ? workflow[0].id : null));
            }, function () {
                defered.reject();
            });

            return promise;
        };

    }

    configurationService.$inject = ["$q", "$rootScope", "$http", "SOLPHEO"];

    angular.module("solpheo").service("solpheo.configurationService", configurationService);

})();
